import { SenderTooltip } from './SenderTooltip'
import { useEffect, useRef, useState } from 'react'
import { useTw } from '../../../../../../../../utils/Styles'
import { ConversationQuery } from '../../../Conversation.generated'
import { useRoot, useSenderInfo } from '../../../../../../../../utils'

type MessageType = ConversationQuery['Conversation']['messages'][0]
type Props = { event: MessageType }

export function Sender({ event }: Props) {
  const tw = useTw()
  const root = useRoot()
  const ref = useRef<HTMLDivElement>()
  const [open, setOpen] = useState(false)
  const sender = useSenderInfo(event)
  useEffect(() => {
    if (ref && ref.current && open) {
      const outsideClick = (e: MouseEvent) => {
        ref.current?.contains(e.target as Node) ? null : setOpen(false)
      }

      root.addEventListener('click', outsideClick)
      return () => root.removeEventListener('click', outsideClick)
    }
  }, [ref, root, open, setOpen])

  return (
    <div className={tw`select-none relative flex-shrink-0 h-10 w-10`} ref={ref}>
      {open && <SenderTooltip event={event} />}
      <img
        src={sender.logoURL}
        alt={`${sender.name} Avatar`}
        onClick={(e) => {
          e.preventDefault()
          setOpen(true)
        }}
        className={tw`inline-block h-10 w-10 object-cover rounded-full cursor-pointer`}
      />
    </div>
  )
}
